<template>
  <div class="container" :class="type" v-if="show">
    <div class="background"></div>
    <!-- <span class="icon" v-if="showIcon">
      <i
        v-if="type == 'warning' || type == 'info'"
        class="el-icon-warning-outline"
      ></i>
      <i v-if="type == 'success'" class="el-icon-circle-check"></i>
      <i v-if="type == 'danger'" class="el-icon-circle-close"></i>
    </span> -->

    <span class="title">{{ title }}</span>
    <span class="description">{{ description }}</span>
  </div>
</template>

<script>
export default {
  name: "AlertTip",
  props: {
    // 显示文字
    title: {
      type: String,
      default: "",
    },
    // 主题，success/warning/info/danger
    type: {
      type: String,
      default: "primary",
    },
    // 辅助性文字
    description: {
      type: String,
      default: "",
    },
    descriptionList: {
      type: Array,
      default: () => [],
    },
    // 是否显示图标
    showIcon: {
      type: Boolean,
      default: true,
    },
    // 是否显示
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>


<style scoped lang="scss">
.container {
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 30px;
  // margin-top: -20px;
  margin-top: 0;

  .icon {
    margin-right: 10px;
  }

  .title {
    margin-right: 10px;
  }

  &.primary {
    border: 1px solid $primaryColor;
    background-color: $warningPlainColor;
  }
  &.success {
    border: 1px solid $successColor;
    background-color: #dbf1e1;
  }
  &.warning {
    border: 1px solid $warningColor;
    background-color: $warningPlainColor;
  }
  &.info {
    border: 1px solid $primaryColor;
    background-color: #ecf5ff;
  }
  &.danger {
    border: 1px solid $dangerColor;
    background-color: #fef0f0;
  }
}
</style>

